import React,{ Component} from 'react';
import { connect } from 'react-redux';

import styles from './styles.module.css';

import ServiceCard from '../../shared/components/ServiceCard';
import SectionTitle from '../../shared/components/SectionTitle';
import { isLoadingServicesList, getServicesList } from '../../shared/state/services/selectors';
import { getEditorialData } from '../../shared/state/editorial/selectors';

const servicesList = [{},{}, {}, {}];

class ServicesList extends Component {
  render() {
        const {servicesList, editorialData: {servicesHeaderImage: {url: photoUrl} = {}}} = this.props;

        return (
            <div className={styles.main}>
                <div className={styles.servicesHeader}>
                    <img src={photoUrl}/>
                </div>
                <div className={styles.services}>
                    <SectionTitle 
                        center={true}
                        title={'Serviços'}
                        subTitle={'Oferecemos solução para vários tipos de serviços'}/>
                    <div className={styles.servicesList}>
                        {
                            servicesList.map((service, i) => (
                                <ServiceCard 
                                    key={i}
                                    service={service}/>
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => {
    return (state) => ({
        isLoadingServices: isLoadingServicesList(state),
        servicesList: getServicesList(state),
        editorialData: getEditorialData(state),
    });
};

export default connect(mapStateToProps)(ServicesList);